import config from '../config';

const stylitics = config({
  default: {
    default: {
      /** Whether the stylitics integration is enabled. */
      enabled: false,
      /** The username for the stylitics account. */
      username: ''
    }
  },
  'HOKA-US': { default: { username: 'hoka' } },
  'UGG-US': { default: { username: 'ugg' } }
});

export default stylitics;
